import { useEffect, useRef } from "react";

import { AUTO_RELOAD_HIDDEN_DELAY_MS, AUTO_RELOAD_IDLE_DELAY_MS } from "../constants";
import { useIsAutoReloadSafe } from "../hooks/useIsAutoReloadSafe";
import { useIsUserAway } from "../hooks/useIsUserAway";
import { hasReachedAutoReloadLimit, recordAutoReload } from "../utils/autoReloadCount";

type AutoReloadSchedulerProperties = {
  onReloadWhenSafe: () => void;
};

export const AutoReloadScheduler = ({ onReloadWhenSafe }: AutoReloadSchedulerProperties): null => {
  const isAutoReloadSafe = useIsAutoReloadSafe();
  const isUserAway = useIsUserAway(AUTO_RELOAD_IDLE_DELAY_MS, AUTO_RELOAD_HIDDEN_DELAY_MS);
  const hasTriggeredReloadRef = useRef(false);

  useEffect(() => {
    if (hasTriggeredReloadRef.current || !isAutoReloadSafe || !isUserAway || hasReachedAutoReloadLimit()) {
      return;
    }

    hasTriggeredReloadRef.current = true;
    recordAutoReload();
    onReloadWhenSafe();
  }, [isAutoReloadSafe, isUserAway, onReloadWhenSafe]);

  return null;
};
